export const resolveRaceGameDevicePixelRatio = ({
  devicePixelRatio = 1,
  viewportWidth = 0,
  viewportHeight = 0,
  maximumRenderPixels = 4000000
} = {}) => {
  const nativeRatio = Number.isFinite(devicePixelRatio)
    ? Math.max(1, devicePixelRatio)
    : 1;
  const width = Math.max(1, viewportWidth || 1);
  const height = Math.max(1, viewportHeight || 1);
  // Keep the cap identical across orientations so rotating a phone does not
  // recreate the Unity instance. 2.5x is near-native on common Android/iOS
  // devices while the pixel budget still protects tablets and older GPUs.
  const mobileQualityCap = 2.5;
  const pixelBudgetRatio = Math.sqrt(
    Math.max(1, maximumRenderPixels) / (width * height)
  );
  const ratio = Math.max(
    1,
    Math.min(nativeRatio, mobileQualityCap, pixelBudgetRatio)
  );
  return Math.round(ratio * 100) / 100;
};
